import type {
	MarkAsFailedInput,
	MarkAsPaidInput,
	PaymentsFacetsInput,
	RevertMultiplePaymentInput,
	RevertSinglePaymentInput,
	assignPaymentOperatorToPaymentsInput,
	checkListedPlayersInput,
	createBatchPaymentInput,
	createPaymentInput,
	getAdminPaymentsFacetsInput,
	getAdminPaymentsInput,
	getAllPaymentsInput,
	getPaymentInput,
	getPoPaymentsFacetsInput,
	getPoPaymentsInput,
	revertPaymentStatusFromFailedToPendingInput,
	revertPaymentsStatusFromFailedToPendingInput,
	updatePaymentInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllPayments: getAllPaymentsInput;
	useGetPoPayments: getPoPaymentsInput;
	useGetAdminPayments: getAdminPaymentsInput;
	useCreatePayment: createPaymentInput;
	useCreateBatchPayment: createBatchPaymentInput;
	useGetPayment: getPaymentInput;
	useUpdatePayment: updatePaymentInput;
	useCheckListedPlayers: checkListedPlayersInput;
	useGetPoPaymentsFacets: getPoPaymentsFacetsInput;
	useGetAdminPaymentsFacets: getAdminPaymentsFacetsInput;
	usePaymentMarkAsFailed: MarkAsFailedInput;
	usePaymentMarkAsPaid: MarkAsPaidInput;
	useGetPaymentsFacets: PaymentsFacetsInput;
	useAssignPaymentOperatorToPayments: assignPaymentOperatorToPaymentsInput;
	useRevertPaymentStatusFromFailedToPending: revertPaymentStatusFromFailedToPendingInput;
	useRevertPaymentsStatusFromFailedToPending: revertPaymentsStatusFromFailedToPendingInput;
	useRevertSinglePayment: RevertSinglePaymentInput;
	useRevertMultiplePayments: RevertMultiplePaymentInput;
}

const PAYMENTS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("payments", [
	"useGetAllPayments",
	"useGetPoPayments",
	"useGetAdminPayments",
	"useCreatePayment",
	"useCreateBatchPayment",
	"useGetPayment",
	"useUpdatePayment",
	"useCheckListedPlayers",
	"useGetPoPaymentsFacets",
	"useGetAdminPaymentsFacets",
	"usePaymentMarkAsFailed",
	"usePaymentMarkAsPaid",
	"useGetPaymentsFacets",
	"useAssignPaymentOperatorToPayments",
	"useRevertPaymentStatusFromFailedToPending",
	"useRevertPaymentsStatusFromFailedToPending",
	"useRevertSinglePayment",
	"useRevertMultiplePayments",
]);

export { PAYMENTS_SERVICE_KEYS };
